import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import PropTypes from 'prop-types';
import { Select } from '../Select/Select';
var standardOptions = [{
  label: 'Excellent 720 - 850',
  value: 720
}, {
  label: 'Good 690 - 719',
  value: 690
}, {
  label: 'Average 630 - 689',
  value: 630
}, {
  label: 'Poor 350 - 629',
  value: 350
}];
var mortgageOptions = [{
  label: 'Excellent 760+',
  value: 760
}, {
  label: 'Excellent 740 - 759',
  value: 740
}, {
  label: 'Good 720 - 739',
  value: 720
}, {
  label: 'Good 700 - 719',
  value: 700
}, {
  label: 'Fair 680 - 699',
  value: 680
}, {
  label: 'Fair 660 - 679',
  value: 660
}, {
  label: 'Poor 640 - 659',
  value: 640
}, {
  label: 'Poor 620 - 639',
  value: 620
}, {
  label: 'Poor 580 - 619',
  value: 580
}, {
  label: 'Poor 300 - 579',
  value: 300
}];
export var CreditScoreRanges = {
  standard: standardOptions,
  mortgage: mortgageOptions
}; // TODO: consider renaming to CreditScoreSelect in v2

/**
 * `InputCreditScore` presents a default set of credit score values within a `Select` component,
 * and enables pods to update the values per their use cases.
 */

export var InputCreditScore = function InputCreditScore(props) {
  return /*#__PURE__*/React.createElement(Select, _extends({
    "aria-label": "Select your credit score",
    "data-currency": "InputCreditScore",
    label: "Credit Score"
  }, props));
};
InputCreditScore.propTypes = {
  /** An array of options `[{ value, label }]`. */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    disabled: PropTypes.bool,

    /** Silence the maxLineLength error to allow a label > 21 characters. Generally only used in instances where copy or compliance requires them. */
    __dangerouslyAllowLongLabel: PropTypes.bool
  })),

  /**
   * The currently selected value. Must match a provided option.
   */
  value: PropTypes.string
};
InputCreditScore.defaultProps = {
  options: CreditScoreRanges.standard,
  value: ''
};